import styled from 'styled-components'

export const Container = styled.header`
  background: ${(props) => props.theme.background};
  top: 0;
  right: 0;
  width: 100%;
  position: fixed;
  z-index: 5;
  height: 6rem;
  padding: 0 1.5rem;

  display: flex;
  align-items: center;
  flex-wrap: wrap;

  & + div,
  & + main,
  & + section {
    margin-top: 6rem;
  }

  @media (${(props) => props.theme.screens.lg}) {
    width: calc(100% - 18rem);
    padding: 3rem 3rem 0rem 3rem;
  }

  @media print {
    position: initial;
    height: 4rem;

    & + div,
    & + main,
    & + section {
      margin-top: 0;
    }
  }

  .header {
    &__navigation {
      min-width: 0; // fix flexbox text overflow ellipsis not showing
    }

    &__caption {
      color: ${(props) => props.theme.text};
      font-size: 0.625rem;
      line-height: 1.25rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (${(props) => props.theme.screens.lg}) {
        font-size: 0.75rem;
      }
    }

    &__title {
      &-container {
        display: flex;
        align-items: center;
      }

      color: ${(props) => props.theme.heading};
      font-size: 1.125rem;
      line-height: 2rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (${(props) => props.theme.screens.lg}) {
        font-size: 1.75rem;
      }
    }

    &__goback {
      display: flex;
      align-items: center;
      margin-right: 0.5rem;

      color: inherit;

      svg {
        width: 1.5rem;
        height: 1.5rem;
        color: inherit;
      }

      @media print {
        display: none;
      }
    }

    &__actions {
      color: ${(props) => props.theme.heading};

      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 1.5rem;

      div,
      svg {
        cursor: pointer;
      }

      > a {
        color: inherit;

        &:hover,
        &:visited {
          color: inherit;
        }
      }

      svg {
        width: 1.5rem;
        height: 1.5rem;
        color: inherit;
      }

      @media print {
        display: none;
      }
    }

    &__avatar {
      img {
        height: 48px;
        width: 48px;
        border-radius: 50%;
      }
    }
  }
`
